import { buildDirectAudience } from '@/features/comms/lib/audienceFilter';
import type {
  DirectAnnouncementPayload,
  WorkerSearchRow,
} from '@/routes/Agency/TestAnnouncement/lib';
import { axiosRubyClient as api } from '@/util/axios/axiosClient';

interface WorkersIndexResponse {
  success: boolean;
  data: Array<{
    id: number;
    active: boolean;
    avatar_url?: string | null;
    user?: {
      id: number;
      first_name?: string | null;
      last_name?: string | null;
      email?: string | null;
    } | null;
  }>;
}

interface CreateBroadcastResponse {
  success: boolean;
  data?: { broadcast_id: string; recipient_count: number };
  errors?: string[];
}

export const testAnnouncementAPI = {
  // GET /api/admin/workers?search= — lightweight worker rows for the picker.
  searchWorkers: async (search: string): Promise<WorkerSearchRow[]> => {
    const res = await api.get<WorkersIndexResponse>('/api/admin/workers', {
      params: { search, per_page: 20 },
    });
    return (res.data.data ?? []).map((r) => ({
      id: r.id,
      active: r.active,
      avatar_url: r.avatar_url ?? null,
      user: r.user
        ? {
            id: r.user.id,
            first_name: r.user.first_name ?? null,
            last_name: r.user.last_name ?? null,
            email: r.user.email ?? null,
          }
        : null,
    }));
  },

  // POST /api/admin/broadcasts (direct mode) — Supabase broadcast row +
  // per-worker fan-out to exactly these User ids.
  sendDirect: async (
    payload: DirectAnnouncementPayload,
  ): Promise<{ success: boolean; id: string | null; errors?: string[] }> => {
    const res = await api.post<CreateBroadcastResponse>(
      '/api/admin/broadcasts',
      {
        content: payload.message,
        title: payload.title,
        expireAt: payload.expireAt,
        message_type: 'broadcast',
        audience_filter: buildDirectAudience(payload.userIds),
      },
    );
    return {
      success: !!res.data.success,
      id: res.data.data?.broadcast_id ?? null,
      errors: res.data.errors,
    };
  },
};
